export default __webpack_public_path__ + "static/media/Belt of the Forsaken.d5214a3f.jpg";